import styles from '../styles/Spinner.module.css'

export default function Spinner() {
  return(
    <div className={styles.lds_ring}><div></div><div></div><div></div><div></div></div>
  )
}
